var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUepay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.64 161.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fefefe;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60,160.88c-9.86.29-11.88-.67-20.39-2.91a62.93,62.93,0,0,1-23.06-11.43Q6.25,138.48,3.13,127.29T0,100V1s33.58,9.42,33.58,33.4V100c0,6,.74,10.91,2.25,14.79a22.56,22.56,0,0,0,6.93,9.62c3.14,2.54,12.79,4.1,17.42,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.13,89.05H98V67.68s-.67-33,33.29-33L131.64.48S64.05-8.6,64.05,52.36V161.28s33.47.66,33.47-24.19V118.21h33.13V99.35C130.65,92.63,125.13,89.05,123.13,89.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M123.15,60.1c0-4.44-4.64-7.27-7-7.27H86.36l.69,27.39h36.1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUepay);
export default __webpack_public_path__ + "static/media/uepay.bbc2ad5b67de34a3f3254338d4f6eb6f.svg";
export { ForwardRef as ReactComponent };